import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SisComunicadoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/comunicado');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Comunicado');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/comunicado', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as  Comunicado');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/comunicado', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as  Comunicado');
      throw error;
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/comunicado/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a  Comunicado');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/comunicado', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a  Comunicado');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/comunicado/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a  Comunicado');
    }
  }
}
